module.exports = __webpack_public_path__ + "static/img/choose_1_5.2a0d5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_1_5.png
// module id = 2cYm
// module chunks = 0